import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { type RouterSpecsFragment } from '../../../api/fragments/RouterSpecs';
import NoItemResult from '../../../components/results/NoItemResult';
import hasPermissions from '../../../utilities/hasPermissions';

export type NoEndpointResultProps = {
    router: RouterSpecsFragment;
};

const NoEndpointResult = ({ router }: NoEndpointResultProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation('routerDetails');

    return (
        <NoItemResult
            extra={
                hasPermissions(router.permissions, [permissionKind.updateRouter]) ? (
                    <Button onClick={() => navigate(`/admin/system/routers/${router.id}/addEndpoint`)} type="primary">
                        {t('routerDetails:noEndpoints.action')}
                    </Button>
                ) : null
            }
            subTitle={t('routerDetails:noEndpoints.message')}
        />
    );
};

export default NoEndpointResult;
